(() => {
  document.documentElement.dataset.urruFunnelReady = 'true';
  if (window.__urruFunnelAnalytics) return;
  window.__urruFunnelAnalytics = true;
  const allowedNames = new Set([
    'urru_finder_start', 'urru_finder_complete', 'urru_finder_result_click',
    'urru_tomorrow_request', 'urru_featured_click', 'urru_trip_open',
    'urru_trip_save', 'urru_trip_remove', 'urru_trip_share', 'urru_trip_price',
    'urru_trip_reserve', 'urru_booking_start', 'urru_booking_submit', 'urru_hero_click'
  ]);
  const safeKeys = new Set(['product_handle', 'position', 'saved_count', 'travelers', 'group', 'zone', 'interests_count', 'budget_band', 'target_date', 'button']);
  const permitted = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
  const send = (name, details = {}) => {
    if (!allowedNames.has(name) || !permitted()) return;
    const safe = { page_path: location.pathname };
    for (const [key, value] of Object.entries(details)) {
      if (safeKeys.has(key) && ['string', 'number', 'boolean'].includes(typeof value)) safe[key] = value;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(['event', name, safe]);
  };
  document.addEventListener('urru:track', (event) => send(event.detail?.name, event.detail || {}));
  let bookingStarted = false;
  document.addEventListener('input', (event) => {
    if (bookingStarted || !event.target.closest?.('.urru-booking-fields')) return;
    bookingStarted = true;
    send('urru_booking_start', { product_handle: location.pathname.split('/products/')[1] || '' });
  }, true);
  document.addEventListener('submit', (event) => {
    if (event.target.querySelector?.('.urru-booking-fields')) send('urru_booking_submit', { product_handle: location.pathname.split('/products/')[1] || '' });
  }, true);
  document.addEventListener('click', (event) => {
    const hero = event.target.closest?.('.urru-hero__actions a');
    if (hero) send('urru_hero_click', { button: hero.classList.contains('urru-hero__cta--secondary') ? 'all_tours' : 'tour_finder' });
  });
})();
